// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
//import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBPE4MYJvJTq8kgwhxDsJM880FRG0QBP7o",
  authDomain: "si-agen-pln.firebaseapp.com",
  projectId: "si-agen-pln",
  storageBucket: "si-agen-pln.firebasestorage.app",
  messagingSenderId: "320760092483",
  appId: "1:320760092483:web:edaed9edd526bec64201f6",
  measurementId: "G-BB7TS2EJM4"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);


export {auth, db}